import { ReactNode } from "react";
import cx from "classnames";

import styles from "./Text.scss";

interface TextProps {
  additionalClasses?: string;
  variant?: "caption" | "primary";
  children: ReactNode;
}

const Text = ({ children, additionalClasses = "", variant = "caption" }: TextProps) => (
  <span
    className={cx(
      { [styles.caption]: variant === "caption", [styles.primary]: variant === "primary" },
      additionalClasses
    )}
  >
    {children}
  </span>
);

export default Text;
